import { ShieldAlert } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useAuthStore } from '@/store/auth.store';

export function MfaGracePeriodBannerComponent() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const endsAt = useAuthStore((s) => s.mfaGracePeriodEndsAt);

  // MFA temporarily disabled — remove this line when re-enabling TOTP.
  if (!isAuthenticated || !endsAt) return null;

  const msRemaining = endsAt.getTime() - Date.now();
  if (msRemaining <= 0) return null;

  const daysLeft = Math.floor(msRemaining / (1000 * 60 * 60 * 24));

  return (
    <div
      role="status"
      className="flex items-center gap-3 border-b bg-amber-50 px-4 py-2 text-sm text-amber-800 dark:bg-amber-950/40 dark:text-amber-200"
    >
      <ShieldAlert className="h-4 w-4 shrink-0" />
      <span className="flex-1">
        {daysLeft === 0 ? (
          'Today is the last day to set up two-factor authentication.'
        ) : (
          <>
            You must set up two-factor authentication.{' '}
            <span className="font-semibold tabular-nums">
              {daysLeft} {daysLeft === 1 ? 'day' : 'days'} remaining.
            </span>
          </>
        )}
      </span>
      <Link
        to="/mfa/enroll"
        className="rounded-md bg-amber-200/60 px-3 py-1 font-medium transition-colors hover:bg-amber-200 dark:bg-amber-900/40 dark:hover:bg-amber-900"
      >
        Set up now
      </Link>
    </div>
  );
}
